<div class="demoHeader" *ngIf="isDemo">
  <div class="row">
      <div *ngIf="!demoPortal" [ngClass]="{'taller': !suppress}" (click)=" restartDemo() " onkeypress="restartDemo()">
        <table style="cursor: pointer;">
          <caption style="display: none;">Demo Header</caption>
          <tbody>
                <tr>
                    <td>
                      <i style="color:#ffffff;" class="fa fa-chevron-circle-right fa-lg" aria-hidden="true"></i>
                      </td>
                    <td><div>
                    <p style="font-size:1.25rem; color:#ffffff; margin-bottom: 0%; margin-left: 3%; white-space: nowrap; ">Restart</p></div></td>
                </tr>
            </tbody>
          </table> 
        </div>
    <div [ngClass]="{'taller': !suppress}" class="col demo-header-text">
      <div class="fake-anchor text-center">
        THIS IS A TEST APPLICATION
      </div>
      
    </div>
    </div>
</div>
